<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<script>
export default {
    name: 'App'
};
</script>

<style lang="scss">
@media (max-width: 992px) {
    body {
        overflow-x: hidden; //horizontal
        overflow-y: scroll; //vertical
        max-width: 100vw !important;
    }
}

.border {
    border: 12px solid #333;
    margin-bottom: 20px;
}

.border-black {
    border-color: #999999 !important;
}

@font-face {
    font-family: ExpresswayRg-Regular;
    src: url('/assets/fonts/expressway_bold.ttf')
}

@font-face {
    font-family: Bebas Neue;
    src: url('/assets/fonts/titulos_bebas_neue.otf')
}

.titulo {
    font-family: "Bebas Neue", sans-serif !important;
    font-size: 250%;
    line-height: 2.4rem;
}

.eslogan {
    font-family: "Bebas Neue", sans-serif !important;
    line-height: 4.5rem;
}

.texto {
    font-family: "Expressway Rg", sans-serif !important;
    line-height: 1.6rem;
    font-size: 150%;
}


.pointer {
    cursor: pointer;
}

.descripcion {
    font-family: "Expressway Rg", sans-serif;
    font-size: 120%;
}

.eslogan.presentacion {
    font-size: 500%;
    background: #FFF;
    z-index: 131;
}

.logos {
    margin-top: -75px;
    z-index: 130;
}

@media (max-width: 992px) {

    .logos {
        margin-top: 30px;
        z-index: 130;
    }

    .eslogan.presentacion {
        font-size: 250%;
        line-height: 4rem;
    }

    h2 {
        font-size: 2.8rem;
        line-height: 1.5rem;
        font-weight: bold;
    }
}

.tituloPres {
    font-family: "Bebas Neue", sans-serif;
    font-size: 250%;
    line-height: 1.8rem;
}

.subtituloPres {
    font-family: "Expressway Rg", sans-serif;
    font-size: 120%;
}

footer > * {
    font-family: "Expressway Rg", sans-serif;
}
</style>


<style>
.eslogan.categoria {
    font-size: 500%;
}

.titulo.categoria {
    font-size: 300%;
    line-height: 3.5rem;
}

@media (max-width: 992px) {
    .titulo.categoria {
        font-size: 200%;
    }

    .eslogan.categoria {
        font-size: 170%;
        line-height: 1.5rem;
    }

    .tituloPres > div > div > h3 {
        font-family: "Bebas Neue", sans-serif;
        font-size: 100%;
        line-height: 2.2rem;
    }
}


html, body {
    overflow-x: hidden;
}
</style>
